// cSpell:ignore Gebouw Privaat Voorbeeldstraat
import { Lozenge, Tooltip } from "@rentiohq/web-shared/dist/components";
import React from "react";
import { ListScreenReaderText, ListTypeBox } from "./listTable.styles";

// The Type cell of the cost list and the settlement list inside a building:
// "Gebouw" or "Privaat" in a plain lozenge. A unit's "Privaat" names the
// unit's full address ("Voorbeeldstraat 9 2, 9000 Gent") in a tooltip, as
// the amount explains a share: the tooltip's trigger is a button, so a
// keyboard reaches it, and a screen reader reads the address after the
// label. Nothing goes under the lozenge (Lewis, 2026-10-16).
export const ListTypeLozenge: React.FC<{
  label: string;
  appearance: "info" | "default";
  address?: string;
}> = ({ label, appearance, address }) => (
  <ListTypeBox>
    <Tooltip tooltipContent={address}>
      <span className="lozenge">
        <Lozenge appearance={appearance}>{label}</Lozenge>
        {address && <ListScreenReaderText>{address}</ListScreenReaderText>}
      </span>
    </Tooltip>
  </ListTypeBox>
);
